import _possibleConstructorReturn from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _classCallCheck from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
export var OrderProjectionDTO = function OrderProjectionDTO() {
  _classCallCheck(this, OrderProjectionDTO);
};
export var Order = function Order() {
  var isVOB = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  _classCallCheck(this, Order);
  this.addOnTests = new Array();
  this.indicationsForTesting = new Array();
  this.tests = new Array(new Test());
  this.patients = new Array(new Patient());
  this.patient = new Array(new Patient());
  this.samples = new Array(new Sample());
  this.recipients = [];
  this.consents = [];
  this.payment = {};
  this.isVOB = isVOB;
  this.kits = [];
  if (isVOB) {
    this.vobStatus = "draft";
  }
};
export var OrderOptions = function OrderOptions() {
  _classCallCheck(this, OrderOptions);
};
export var VAStation = function VAStation() {
  _classCallCheck(this, VAStation);
};
export var FamilySequencing = function FamilySequencing() {
  _classCallCheck(this, FamilySequencing);
};
export var SequencingTest = function SequencingTest() {
  _classCallCheck(this, SequencingTest);
};
export var AddFeedbackDTO = function AddFeedbackDTO() {
  _classCallCheck(this, AddFeedbackDTO);
};
export var KitToSend = function KitToSend() {
  _classCallCheck(this, KitToSend);
  this.kitType = "";
  this.kitNeededByDate = undefined;
  this.quantity = 1;
  this.kitRecipient = new KitRecipient();
};
export var KitRecipient = function KitRecipient() {
  _classCallCheck(this, KitRecipient);
  this.firstName = "";
  this.lastName = "";
  this.address1 = "";
  this.address2 = "";
  this.city = "";
  this.zipCode = "";
  this.state = "";
  this.phone = "";
};
export var ImagingOption = function ImagingOption() {
  _classCallCheck(this, ImagingOption);
};
export var PrenatalTestingCompleted = function PrenatalTestingCompleted() {
  _classCallCheck(this, PrenatalTestingCompleted);
  this.aneuploidyFish = undefined;
  this.chromosomalMicroarrayAnalysis = undefined;
  this.chromosomsAndKaryotype = undefined;
  this.maternalSerumScreening = undefined;
  this.nonInvasivePrenatalScreening = undefined;
  this.other = undefined;
  this.detailForAbnormalResult = undefined;
};
export var CounselHistory = function CounselHistory(priorTestPerformed) {
  _classCallCheck(this, CounselHistory);
  this.counselor = undefined;
  this.dateOfCollection = undefined;
  this.additionalCulture = undefined;
  this.labFrom = undefined;
  this.priorTestPerformed = priorTestPerformed;
  this.bgFamilyNumber = undefined;
};
export var TestOption = function TestOption() {
  _classCallCheck(this, TestOption);
  this.targetSequencing = false;
  this.targetSequencingData = {
    testCode: "",
    gene: "",
    probandLastName: "",
    probandFirstName: "",
    relationshipToProband: "",
    dateOfBirth: undefined,
    testingLocation: {
      name: "",
      labNumber: "",
      familyNumber: ""
    }
  };
  this.fullGeneSequencing = false;
  this.deletionDuplicationAnalysis = false;
};
export var TestingLocationData = function TestingLocationData() {
  _classCallCheck(this, TestingLocationData);
};
export var NewDocument = function NewDocument() {
  _classCallCheck(this, NewDocument);
  this.title = "";
  this.description = "";
  this.typeId = 0;
  this.institutionCode = "";
};
export var Document = /*#__PURE__*/function (_NewDocument) {
  _inherits(Document, _NewDocument);
  function Document() {
    _classCallCheck(this, Document);
    return _possibleConstructorReturn(this, _getPrototypeOf(Document).apply(this, arguments));
  }
  return Document;
}(NewDocument);
export var OrderManifest = /*#__PURE__*/function (_NewDocument2) {
  _inherits(OrderManifest, _NewDocument2);
  function OrderManifest() {
    _classCallCheck(this, OrderManifest);
    return _possibleConstructorReturn(this, _getPrototypeOf(OrderManifest).apply(this, arguments));
  }
  return OrderManifest;
}(NewDocument);
export var ManifestUploadResult = function ManifestUploadResult() {
  _classCallCheck(this, ManifestUploadResult);
};
export var IndicationForTestingOrder = function IndicationForTestingOrder() {
  _classCallCheck(this, IndicationForTestingOrder);
};
export var Note = function Note() {
  _classCallCheck(this, Note);
};
export var OrderPhysician = function OrderPhysician(physician) {
  _classCallCheck(this, OrderPhysician);
  if (physician) {
    this.fax = physician.fax || undefined;
    this.firstName = physician.firstName || undefined;
    this.lastName = physician.lastName || undefined;
    this.locationName = physician.locationName || undefined;
    this.npi = physician.npi || undefined;
    this.phone = physician.phone || undefined;
    this.prefix = physician.prefix || undefined;
    this.suffix = physician.suffix || undefined;
    this.institutionId = physician.institutionId || undefined;
    this.physicianId = physician.physicianId || undefined;
    this.status = physician.status || undefined;
    this.emails = physician.emails || undefined;
    this.id = physician.id || undefined;
  }
};
export var PreviousTesting = function PreviousTesting() {
  _classCallCheck(this, PreviousTesting);
};
export var AdditionalStudy = function AdditionalStudy() {
  _classCallCheck(this, AdditionalStudy);
};
export var FamilyDiagnosis = function FamilyDiagnosis() {
  _classCallCheck(this, FamilyDiagnosis);
};
export var FamilyHistory = function FamilyHistory(beingTested) {
  _classCallCheck(this, FamilyHistory);
  this.familyHistoryOfDiseaseBeingTested = beingTested;
  this.familyDiagnosis = beingTested ? [new FamilyDiagnosis()] : undefined;
};
export var Patient = function Patient() {
  _classCallCheck(this, Patient);
  this.addresses = new Array(new PatientAddress());
  this.contacts = new Array(new PatientContact(OrderContactType.Phone), new PatientContact(OrderContactType.Email));
};
export var PatientAddress = function PatientAddress() {
  _classCallCheck(this, PatientAddress);
  this.type = "Primary";
};
export var PatientContact = function PatientContact(type) {
  _classCallCheck(this, PatientContact);
  if (type === undefined) {
    this.type = OrderContactType.Phone;
  } else {
    this.type = type;
  }
  this.reference = OrderContactReference.Home;
};
export var Payment = function Payment() {
  _classCallCheck(this, Payment);
  this.insurances = new Array(new Insurance());
};
export var Insurance = function Insurance() {
  _classCallCheck(this, Insurance);
};
export var Estimate = function Estimate() {
  _classCallCheck(this, Estimate);
};
export var Recipient = function Recipient() {
  _classCallCheck(this, Recipient);
};
export var Sample = function Sample() {
  _classCallCheck(this, Sample);
};
export var SurgicalPathology = function SurgicalPathology() {
  _classCallCheck(this, SurgicalPathology);
};
export var SpecimenRetrieval = function SpecimenRetrieval() {
  _classCallCheck(this, SpecimenRetrieval);
};
export var SpecimenReturn = function SpecimenReturn() {
  _classCallCheck(this, SpecimenReturn);
};
export var Test = function Test() {
  _classCallCheck(this, Test);
};
export var NewInstitution = function NewInstitution() {
  _classCallCheck(this, NewInstitution);
  this.addresses = [];
  this.phoneNumbers = [];
};
export var Institution = /*#__PURE__*/function (_NewInstitution) {
  _inherits(Institution, _NewInstitution);
  function Institution() {
    _classCallCheck(this, Institution);
    return _possibleConstructorReturn(this, _getPrototypeOf(Institution).apply(this, arguments));
  }
  return Institution;
}(NewInstitution);
export var NewPhysicianDTO = function NewPhysicianDTO() {
  _classCallCheck(this, NewPhysicianDTO);
  this.firstName = "";
  this.lastName = "";
  this.npi = null;
  this.title = "";
  this.credential = "";
  this.addresses = [];
  this.phoneNumbers = [];
  this.emails = [];
};
export var NewAddress = function NewAddress() {
  _classCallCheck(this, NewAddress);
};
export var Address = /*#__PURE__*/function (_NewAddress) {
  _inherits(Address, _NewAddress);
  function Address() {
    _classCallCheck(this, Address);
    return _possibleConstructorReturn(this, _getPrototypeOf(Address).apply(this, arguments));
  }
  return Address;
}(NewAddress);
export var NewPhone = function NewPhone() {
  _classCallCheck(this, NewPhone);
};
export var Phone = /*#__PURE__*/function (_NewPhone) {
  _inherits(Phone, _NewPhone);
  function Phone() {
    _classCallCheck(this, Phone);
    return _possibleConstructorReturn(this, _getPrototypeOf(Phone).apply(this, arguments));
  }
  return Phone;
}(NewPhone);
export var NewEmail = function NewEmail() {
  _classCallCheck(this, NewEmail);
};
var Email = /*#__PURE__*/function (_NewEmail) {
  _inherits(Email, _NewEmail);
  function Email() {
    _classCallCheck(this, Email);
    return _possibleConstructorReturn(this, _getPrototypeOf(Email).apply(this, arguments));
  }
  return Email;
}(NewEmail);
var Specialty = function Specialty() {
  _classCallCheck(this, Specialty);
};
var PhysicianBasicDTO = function PhysicianBasicDTO() {
  _classCallCheck(this, PhysicianBasicDTO);
};
export var OrderContactType;
(function (OrderContactType) {
  OrderContactType["Phone"] = "Phone";
  OrderContactType["Fax"] = "Fax";
  OrderContactType["Email"] = "Email";
  OrderContactType["Pager"] = "Pager";
  OrderContactType["Url"] = "Url";
  OrderContactType["Sms"] = "Sms";
  OrderContactType["Other"] = "Other";
})(OrderContactType || (OrderContactType = {}));
export var OrderContactReference;
(function (OrderContactReference) {
  OrderContactReference["Home"] = "Home";
  OrderContactReference["Work"] = "Work";
  OrderContactReference["Temp"] = "Temp";
  OrderContactReference["Old"] = "Old";
  OrderContactReference["Mobile"] = "Mobile";
})(OrderContactReference || (OrderContactReference = {}));
var AddressTypeEnum;
(function (AddressTypeEnum) {
  AddressTypeEnum["Primary"] = "Primary";
  AddressTypeEnum["Billing"] = "Billing";
  AddressTypeEnum["Mailing"] = "Mailing";
})(AddressTypeEnum || (AddressTypeEnum = {}));
var EmailTypeEnum;
(function (EmailTypeEnum) {
  EmailTypeEnum["Personal"] = "Personal";
  EmailTypeEnum["Work"] = "Work";
})(EmailTypeEnum || (EmailTypeEnum = {}));
export var CommunicationMethodEnum;
(function (CommunicationMethodEnum) {
  CommunicationMethodEnum["Fax"] = "Fax";
  CommunicationMethodEnum["Email"] = "Email";
  CommunicationMethodEnum["Mail"] = "Mail";
  CommunicationMethodEnum["Any"] = "Any";
  CommunicationMethodEnum["Phone"] = "Phone";
})(CommunicationMethodEnum || (CommunicationMethodEnum = {}));
var PhoneTypeEnum;
(function (PhoneTypeEnum) {
  PhoneTypeEnum["Home"] = "Home";
  PhoneTypeEnum["Work"] = "Work";
  PhoneTypeEnum["Cell"] = "Cell";
  PhoneTypeEnum["Fax"] = "Fax";
})(PhoneTypeEnum || (PhoneTypeEnum = {}));
export var CustomerStatus;
(function (CustomerStatus) {
  CustomerStatus["Active"] = "Active";
  CustomerStatus["Inactive"] = "Inactive";
  CustomerStatus["Blocked"] = "Blocked";
  CustomerStatus["WaitingForApproval"] = "WaitingForApproval";
})(CustomerStatus || (CustomerStatus = {}));
export var CustomerStatusDisplayName;
(function (CustomerStatusDisplayName) {
  CustomerStatusDisplayName["Active"] = "Active";
  CustomerStatusDisplayName["Inactive"] = "Inactive";
  CustomerStatusDisplayName["Blocked"] = "Blocked";
  CustomerStatusDisplayName["WaitingForApproval"] = "Waiting For Approval";
})(CustomerStatusDisplayName || (CustomerStatusDisplayName = {}));
export var IndicationOptionType;
(function (IndicationOptionType) {
  IndicationOptionType["None"] = "None";
  IndicationOptionType["AdditionalTextOptional"] = "AdditionalTextOptional";
  IndicationOptionType["AdditionalTextRequired"] = "AdditionalTextRequired";
  IndicationOptionType["SingleOptional"] = "SingleOptional";
  IndicationOptionType["SingleRequired"] = "SingleRequired";
  IndicationOptionType["MultipleOptional"] = "MultipleOptional";
  IndicationOptionType["MultipleRequired"] = "MultipleRequired";
  IndicationOptionType["Custom"] = "Custom";
})(IndicationOptionType || (IndicationOptionType = {}));
export var PatientType;
(function (PatientType) {
  PatientType["Proband"] = "Proband";
  PatientType["Other"] = "Other";
  PatientType["Maternal"] = "Maternal";
  PatientType["Paternal"] = "Paternal";
  PatientType["EggDonor"] = "EggDonor";
  PatientType["FamilyMember"] = "FamilyMember";
})(PatientType || (PatientType = {}));
export var IndicationForTesting = function IndicationForTesting() {
  _classCallCheck(this, IndicationForTesting);
};
export var PatientOrderDetailsDTO = function PatientOrderDetailsDTO() {
  _classCallCheck(this, PatientOrderDetailsDTO);
};
export var FileInfoDTO = function FileInfoDTO() {
  _classCallCheck(this, FileInfoDTO);
};
export var IcdCodeDTO = function IcdCodeDTO() {
  _classCallCheck(this, IcdCodeDTO);
};
export var CustomerTestDTO = function CustomerTestDTO() {
  _classCallCheck(this, CustomerTestDTO);
};
export var CustomerIcdCodeDTO = function CustomerIcdCodeDTO() {
  _classCallCheck(this, CustomerIcdCodeDTO);
};
export var CustomerNotificationDTO = function CustomerNotificationDTO() {
  _classCallCheck(this, CustomerNotificationDTO);
};
export var OrderGeneDTO = function OrderGeneDTO() {
  _classCallCheck(this, OrderGeneDTO);
};
export var TestAddOnDTO = function TestAddOnDTO() {
  _classCallCheck(this, TestAddOnDTO);
};
export var ConsentDTO = function ConsentDTO() {
  _classCallCheck(this, ConsentDTO);
};
export var ConsentDTONew = function ConsentDTONew() {
  _classCallCheck(this, ConsentDTONew);
};
export var RoleType;
(function (RoleType) {
  RoleType["SuperUser"] = "SuperUser";
  RoleType["UserAdmin"] = "UserAdmin";
  RoleType["OrderCreator"] = "OrderCreator";
  RoleType["OrderSubmitter"] = "OrderSubmitter";
  RoleType["OrderViewer"] = "OrderViewer";
})(RoleType || (RoleType = {}));
export var PermissionType;
(function (PermissionType) {
  PermissionType["CreateUser"] = "CreateUser";
  PermissionType["ViewUser"] = "ViewUser";
  PermissionType["CreateOrder"] = "CreateOrder";
  PermissionType["SubmitOrder"] = "SubmitOrder";
  PermissionType["ViewOrder"] = "ViewOrder";
})(PermissionType || (PermissionType = {}));